import { z } from 'zod';

export const deleteTrainingSchema = z.object({
  training_id: z.uuid('Invalid training ID'),
});

export type DeleteTrainingPayload = z.infer<typeof deleteTrainingSchema>;
